export const notificationFileType = [
    {
        text: 'Link',
        value: 'LINK'
    },
    {
        text: 'Upload file',
        value: 'FILE_UPLOAD'
    }
]